import { MailAuthGate } from "@/features/gate/MailAuthGate";
import { MailAppErrorBoundary } from "@/features/gate/MailAppErrorBoundary";
import { MailWebPushBoot } from "@/features/shell/MailWebPushBoot";
import { MailPwaOnboard } from "@/features/shell/MailPwaOnboard";
import { MailSendLeaveDialog } from "@/features/shared/MailSendLeaveDialog";
import { MailToastHost } from "@/features/shared/MailToastHost";
import { MailWorkspace } from "@/features/workspace/MailWorkspace";
import { CoffreSuiteStatusProvider } from "@/hooks/useCoffreSuiteStatus";
import { MailCoffreUnlockHost } from "@/features/shell/MailCoffreUnlockModal";
import { MailContactsProvider } from "@/hooks/useMailContacts";
import { MailThemeProvider } from "@/hooks/useMailTheme";
import { MobileMailApp } from "@/mobile/MobileMailApp";
import { useIsMobileMail } from "@/mobile/hooks/useIsMobileMail";

export default function App() {
  const isMobile = useIsMobileMail();

  return (
    <MailAppErrorBoundary>
      <MailThemeProvider>
        <MailToastHost />
        <MailSendLeaveDialog />
        <MailAuthGate>
          <MailWebPushBoot />
          <MailPwaOnboard />
          <CoffreSuiteStatusProvider>
            <MailCoffreUnlockHost />
            {isMobile ? (
              <MailContactsProvider>
                <MobileMailApp />
              </MailContactsProvider>
            ) : (
              <MailWorkspace />
            )}
          </CoffreSuiteStatusProvider>
        </MailAuthGate>
      </MailThemeProvider>
    </MailAppErrorBoundary>
  );
}
